<template>
  <div>
    <search-form />
    <router-view />
  </div>
</template>
<script>
import SearchForm from "./components/SearchForm.vue";
export default {
  components: {
    SearchForm,
  },
};
</script>
